export function getImPointsDiscount(order) {
  if (!order) return 0;
  const v = Number(order.imPointsDiscount);
  return Number.isFinite(v) ? Math.max(0, v) : 0;
}

/** Gross order value before IM (mkp grand incl. GST + shipping) when stored on order. */
export function getGrossBeforeImFromOrder(order, fallbackGross) {
  const mkp = Number(order?.mkp_current_total_price) || 0;
  const ship = Number(order?.totalShippingCharges) || 0;
  if (mkp > 0 || ship > 0) return mkp + ship;
  const f = Number(fallbackGross);
  return Number.isFinite(f) ? f : 0;
}

/**
 * Final amount paid / payable after IM, from stored fields only.
 * @param {object} order
 * @param {number} [grossBeforeIm] - pre-IM total if already computed (e.g. seller pricing helper)
 */
export function getFinalPayableAfterIm(order, grossBeforeIm) {
  const ap = order?.amountPayableAfterImPoints;
  if (ap != null && Number.isFinite(Number(ap))) return Number(ap);
  const g =
    grossBeforeIm != null && Number.isFinite(Number(grossBeforeIm))
      ? Number(grossBeforeIm)
      : getGrossBeforeImFromOrder(order);
  return Math.max(0, g - getImPointsDiscount(order));
}
